import * as React from "react";

import { Confirm, MeasureType } from "./Chapters";

export default ({ key, method }) => {
  switch (key) {
    case "MEASURE_TYPE":
      return <MeasureType {...{ method }} />;
    default:
      return <Confirm {...{ method }} />;
  }
};
